import 'styled-components/macro';

import {
  mobileV3ThemeCustomizationSchema,
  mobileV3ThemeCustomizationUiSchema,
} from '../../../../../components/JsonEditor/constants/ThemeSchema/mobileV3ThemeCustomizationSchema';

import CustomizeTheme from '../../../../../components/CustomizeTheme';
import { CustomizeThemeLocalizationEntityLevel } from '../../../../../enums/CustomizeThemeLocalizationEntityLevel';
import React from 'react';
import { ThemeComponentName } from '../../../../../enums/ComponentNameEnum';
import { useParams } from 'react-router-dom';

const CustomizeMobileV3Theme: React.FC<{}> = () => {
  const { tenantId } = useParams<{ tenantId: string }>();

  return (
    <CustomizeTheme
      schema={mobileV3ThemeCustomizationSchema}
      uiSchema={mobileV3ThemeCustomizationUiSchema}
      componentName={ThemeComponentName.MOBILE_V3}
      fileNameToDownloadDefaultJson={`Default Mobile v3 theme - Tenant ${tenantId}.json`}
      fileNameToDownloadCurrentJson={`Current Mobile v3 theme - Tenant ${tenantId}.json`}
      title={'Customize mobile v3 theme'}
      entityLevel={CustomizeThemeLocalizationEntityLevel.TENANT}
      entityId={tenantId}
    />
  );
};

export default CustomizeMobileV3Theme;
